<template>
  <Page title="Nutzungsrichtlinien" color="grey">
    <v-alert
      :prominent="!$vuetify.breakpoint.xs"
      class="ma-0 rounded-t-0"
      icon="mdi-file-document-check-outline"
      color="primary"
      text
      v-if="!policyAlreadyAccepted"
    >
      Du hast unsere Nutzungsrichtlinien noch nicht akzeptiert oder sie wurden
      seitdem angepasst. Bitte lies die Richtlinien durch und akzeptiere sie.
    </v-alert>
    <v-alert
      :prominent="!$vuetify.breakpoint.xs"
      class="ma-0 rounded-t-0"
      icon="mdi-file-document-check-outline"
      color="success"
      text
      v-else
    >
      Du hast unsere Nutzungsrichtlinien gelesen und akzeptiert. Vielen Dank!
    </v-alert>

    <v-card max-width="800" class="mx-auto my-4" :loading="loading">
      <v-system-bar window :color="policyAccepted ? 'success' : 'danger'">
        Nutzungsrichtlinien</v-system-bar
      >
      <div>
        <DocumentItemLoader :id="202181" />
        <v-divider></v-divider>
      </div>

      <v-card-text>
        <Markdown :value="policy" class="mt-4" />

        <v-alert
          v-if="!policyAlreadyAccepted"
          text
          outlined
          :color="policyAccepted ? 'success' : 'danger'"
        >
          <v-checkbox
            v-model="policyAccepted"
            color="primary"
            label="ich habe die Richtlinien gelesen und akzeptiere diese"
          ></v-checkbox>
        </v-alert>
      </v-card-text>

      <v-divider v-if="!policyAlreadyAccepted"></v-divider>

      <v-card-actions v-if="!policyAlreadyAccepted">
        <v-btn
          color="primary"
          block
          text
          @click="save"
          :disabled="!policyAccepted"
          :loading="saving"
          >speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </Page>
</template>
<script>
import { defineComponent } from "vue";
import DocumentItemLoader from "@/components/DocumentItemLoader.vue";
import policy from "raw-loader!@/assets/policy.md";

export default defineComponent({
  name: "Policy",
  components: { DocumentItemLoader },
  data() {
    return {
      policy: policy,
      policyAccepted: false,
      policyAlreadyAccepted: false,
      loading: false,
      saving: false,
    };
  },
  computed: {},
  methods: {
    async fetchData() {
      this.loading = true;
      const data = await this.apiList({
        resource: "account/policy",
      });
      this.policyAccepted = data.policyAccepted;
      this.policyAlreadyAccepted = data.policyAccepted;
      this.loading = false;
    },
    async save() {
      this.saving = true;
      await this.apiPost({
        resource: "account/policy",
        data: { policyAccepted: true },
      });

      this.fetchData();
      this.saving = false;
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
